<template>
  <div>
    <div class="row">
      <div class="col">
        <button @click="goBack()" class="btn btn-secondary m-3">Back</button>
      </div>
    </div>

    <div class="row align-items-center m-3">
      <div class="col">
        <div>
          <p class="h1 t-race">{{ getReportName }}</p>
        </div>
      </div>
    </div>

    <div class="row align-items-center m-3">
      <div class="col">
        <div>
          <div class="dropdown show">
            <a
              class="btn btn-secondary dropdown-toggle"
              @click="toggleDropdown()"
              href="#"
              role="button"
              id="dropdownMenuLink"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              EXPORTS
            </a>

            <div
              v-bind:class="dropdownToggle"
              aria-labelledby="dropdownMenuLink"
            >
              <a @click="openLink('CSV')" class="dropdown-item" href="#">CSV</a>
              <a @click="openLink('XL')" class="dropdown-item" href="#"
                >Excel</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="displayBox table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th rowspan="2">Dr</th>
            <th rowspan="2">Horse Name</th>
            <th rowspan="2">Weight</th>
            <th rowspan="2">Start</th>

            <th v-for="section in sections" :key="section" colspan="2">
              {{ section }}
            </th>

            <th rowspan="2">Finish Rank</th>
          </tr>

          <tr>
            <th v-for="column in sectionColumns" :key="column.key">
              {{ column.label }}
            </th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="horse in horses" :key="getHorseNumber(horse)">
            <td>{{ getHorseNumber(horse) }}</td>

            <td>
              <div class="horse-details">
                <div class="horse-name-area">
                  {{ getValue(horse, "horse", "Horse") }}
                </div>

                <div class="trainer-jockey-area">
                  <div class="trainer">
                    {{ jockeyTrainerText(horse) }}
                  </div>
                </div>
              </div>
            </td>

            <td>
              <div class="horse-details">
                <div>
                  {{ formatDecimal(getValue(horse, "weight", "Weight")) }}
                </div>
                <div class="trainer-jockey-area">
                  <div class="trainer">
                    {{
                      formatDecimal(
                        getValue(horse, "weightAllowed", "WeightAllowed"),
                      )
                    }}
                  </div>
                </div>
              </div>
            </td>
            <td>{{ getValue(horse, "startPosition", "StartPosition") }}</td>

            <td
              v-for="column in sectionColumns"
              :key="column.key + '-' + getHorseNumber(horse)"
            >
              {{ getSectionValue(horse, column.section)[column.type] }}
            </td>

            <td>{{ getValue(horse, "raceRank", "RaceRank") }}</td>
          </tr>
        </tbody>

        <tfoot></tfoot>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { config } from "../../config";

export default {
  name: "SectionsToFinishReport",

  data() {
    return {
      dropdownToggle: "dropdown-menu",
      dropdownStatus: false,
    };
  },

  computed: {
    ...mapGetters(["getReportSectional", "getReportName"]),

    reportData() {
      return (
        this.getReportSectional || {
          resultData: [],
          ResultData: [],
          sections: [],
          Sections: [],
        }
      );
    },

    horses() {
      return this.reportData.resultData || this.reportData.ResultData || [];
    },

    sections() {
      return this.reportData.sections || this.reportData.Sections || [];
    },

    sectionColumns() {
      return this.sections.reduce((columns, section) => {
        columns.push({
          key: section + "-rank",
          section: section,
          label: "Rank",
          type: "rank",
        });

        columns.push({
          key: section + "-time",
          section: section,
          label: "Time",
          type: "time",
        });

        return columns;
      }, []);
    },
  },

  methods: {
    goBack() {
      this.$router.push("/landing/SectionsToFinishFilter");
    },

    getValue(item, camelKey, pascalKey) {
      if (!item) return "";
      return item[camelKey] !== undefined ? item[camelKey] : item[pascalKey];
    },

    getHorseNumber(horse) {
      return this.getValue(horse, "horseNumber", "HorseNumber");
    },

    getSectionValue(horse, sectionName) {
      const horseSections = this.getValue(horse, "sections", "Sections") || [];

      const section = horseSections.find((item) => {
        const name = this.getValue(item, "sectionName", "SectionName");
        return name === sectionName;
      });

      if (!section) {
        return {
          rank: "",
          time: "",
        };
      }

      return {
        rank: this.getValue(section, "rank", "Rank"),
        time: this.formatNumber(this.getValue(section, "time", "Time")),
      };
    },

    jockeyTrainerText(horse) {
      const jockey = this.getValue(horse, "jockey", "Jockey");
      const trainer = this.getValue(horse, "trainer", "Trainer");

      if (!jockey && !trainer) return "";
      if (!jockey || jockey === "-") return trainer || "";
      if (!trainer || trainer === "-") return jockey || "";

      return `${jockey} / ${trainer}`;
    },

    formatNumber(value) {
      if (value === null || value === undefined || value === "") {
        return "";
      }

      const number = Number(value);

      if (Number.isNaN(number)) {
        return value;
      }

      return Number.isInteger(number) ? number : number.toFixed(2);
    },

    formatDecimal(value) {
      if (value === null || value === undefined || value === "") {
        return "";
      }

      const number = Number(value);

      if (Number.isNaN(number)) {
        return value;
      }

      return number.toFixed(2);
    },

    toggleDropdown() {
      this.dropdownStatus = !this.dropdownStatus;
      this.dropdownToggle = this.dropdownStatus
        ? "dropdown-menu show"
        : "dropdown-menu";
    },

    openLink(fileType) {
      const firstHorse = this.horses[0];

      if (!firstHorse) return;

      const raceCourse = this.getValue(
        firstHorse,
        "raceCourseCode",
        "RaceCourseCode",
      );

      const raceNumber = this.getValue(firstHorse, "raceNumber", "RaceNumber");

      const meetingDate = this.getValue(
        firstHorse,
        "meetingDate",
        "MeetingDate",
      );

      window.open(
        `${config.reportingURL}/api/Reports/GetSectionToFinishFile?rc=${raceCourse}&startDate=${meetingDate}&rn=${raceNumber}&fileType=${fileType}`,
        "_blank",
      );
    },
  },
};
</script>

<style scoped>
.horse-details {
  display: flex;
  flex-direction: column;
}

.table {
  border-collapse: separate;
  border-spacing: 2px;
}

.trainer-jockey-area {
  display: flex;
  flex-direction: row;
  font-style: italic;
  color: grey;
  margin-inline: auto;
}

.trainer,
.jockey {
  padding-inline: 0.3rem;
  font-size: 0.69rem;
}

.trainer {
  padding-right: 0.5rem;
}

.displayBox {
  max-height: 80vh;
  width: 95%;
  overflow: scroll;
  margin-inline: auto;
}

th {
  color: white !important;
  text-align: center;
  font-weight: bold;
  background-color: #4caee3 !important;
}

tr:hover {
  background-color: black;
  color: white;
}

.t-race {
  text-align: center;
}

td {
  text-align: center;
}

.table td,
.table th {
  padding: 0.3rem;
  vertical-align: top;
  border-top: 1px solid #dee2e6;
}

.container {
  width: 100% !important;
}
</style>
